import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectCustomerDialogComponent } from './select-customer-dialog.component';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { DialogLayoutModule } from '@tcc-mono/shared/ui/dialog-layout';
import { ListSearchHeaderModule } from '@tcc-mono/shared/ui/list-search-header';
import { StackedListModule } from '@tcc-mono/shared/ui/stacked-list';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    DialogLayoutModule,
    TranslocoModule,
    StackedListModule
  ],
  declarations: [SelectCustomerDialogComponent],
  exports: [SelectCustomerDialogComponent]
})
export class SelectCustomerDialogModule { }
